import { GridValidRowModel, GridValueFormatter } from '@mui/x-data-grid-pro';
import { NumberFormatPreset, formatNumber } from '@procureai/ui-mui';
import { isNil } from 'ramda';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../DataGridCustom.types';

type NumberFormatterValue = Union.Nullable<number>;

interface NumberFormatterFactoryOptions {
  preset: NumberFormatPreset;
}

export const numberFormatterFactory = <R extends GridValidRowModel = any>(
  options: NumberFormatterFactoryOptions,
): GridValueFormatter<R> => {
  return (value: NumberFormatterValue) => {
    try {
      return !isNil(value) ? formatNumber(options.preset, value) : NULLISH_CELL_VALUE;
    } catch (e) {
      console.log(e);
    }
    return NULLISH_CELL_VALUE;
  };
};
